import { render, staticRenderFns } from "./ALoader.vue?vue&type=template&id=1ed52c32&"
import script from "./ALoader.vue?vue&type=script&lang=js&"
export * from "./ALoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSpinnerBars} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSpinnerBars})
